<ngb-datepicker class="rui-datepicker" *ngIf="datePicker" #dp (select)="onDateSelection($event, null)" [displayMonths]="2" [dayTemplate]="t"
  outsideDays="hidden" [minDate]="minDate" [maxDate]="maxDate" [markDisabled]="markDisabled">
</ngb-datepicker>
<ng-container *ngIf="!datePicker">
  <div class="input-group">
    <!-- <input
      type="hidden"
      [autoClose]="true"
      [displayMonths]="2"
      [dayTemplate]="t"
      ngbDatepicker
      #d="ngbDatepicker"
      (dateSelect)="onDateSelection($event)"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [displayMonths]="2"
      [markDisabled]="markDisabled"
    /> -->
    <div class="date-input-elem" #inputDateElem style="
   
" (click)="d.open()">
      <span>
        {{ (setDateData(dates?.fromDate) | date:'mediumDate') }}
      </span>
      <svg style="position: relative;top: 5px;color: var(--primary_color);" viewBox="64 64 896 896" focusable="false" fill="currentColor" width="1em" height="1em" data-icon="swap" aria-hidden="true" class=""><path d="M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"></path></svg>
      <span>
        {{ (setDateData(dates?.toDate) | date:'mediumDate') }}
      </span>

      <input type="text" class="calendar-picker form-control hidden" [(ngModel)]="dateRange" [autoClose]="'outside'"
        placeholder="Start Date &nbsp;&nbsp;End Date" [displayMonths]="2" [dayTemplate]="t" ngbDatepicker
        #d="ngbDatepicker" (dateSelect)="onDateSelection($event, d)" [minDate]="minDate" [maxDate]="maxDate"
        [displayMonths]="2" [markDisabled]="markDisabled" (click)="d.toggle()" [positionTarget]="inputDateElem"
        readonly />
    </div>
    <!-- <span class="start-date">Start Date</span>
    <span class="end-date">End Date</span> -->

    <!-- <div class="input-group-append">
      <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"></button>
    </div> -->
  </div>
</ng-container>
<ng-template #t let-date let-focused="focused" let-disabled="disabled">
  <span [ngbTooltip]="getTooltip(date)" class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
    [class.faded]="isHovered(date) || isInside(date)" [class.reservation]="storeDates(date)"
    [class.has-reservation]="hasReservation(date)" [class.disabled]="disabled || hasReservation(date)"
    (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
    {{ date.day }}
  </span>
</ng-template>